module.exports = __webpack_public_path__ + "img/glasses-3.d781fd13.svg";